import { Component } from '@angular/core';

@Component({
  selector: 'app-coas',
  templateUrl: './coas.component.html',
  styleUrls: ['./coas.component.scss']
})
export class CoasComponent {

}
